import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { promotions } from '../Promotions/Promotions.constants';
import { getLessPrice } from '../Promotions/Promotions.helpers';
import { Promotion } from '../Promotions/Promotion';
import { PromotionDrawer } from '../Promotions/PromotionDrawer';
import * as S from './RestoredAdDrawer.styles';
import { Drawer } from '@/components/Drawer/Drawer';
import { Button } from '@/components/UI/Button/Button';
import { useAdDetails } from '@/views/Ads/useAdDetails';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { AdStatus } from '@/types';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { AdKind } from '@/api/types/common.types';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';

interface RestoredAdDrawerProps {
  isOpen: boolean;
  toggle: () => void;
}

export const RestoredAdDrawer = ({ isOpen, toggle }: RestoredAdDrawerProps) => {
  const { t } = useTranslation();
  const { adDetails } = useAdDetails();
  const [isDrawerOpen, toggleDrawer] = useToggleOpenState();
  const [type, setType] = useState<null | AdKind>(null);

  return (
    <Drawer
      dataTestId={AdPageTestIds.statusBanner.restoredAdDrawer}
      isHeadFixed={false}
      hasBottomMargin={false}
      isOpen={isOpen}
      close={toggle}
      title={t('pages.ad.ad_is_restored')}
      subtitleVariant="4"
      bottom={
        <Button
          appearance="secondary"
          isFullWidth
          onClick={toggle}
          data-testid={AdPageTestIds.statusBanner.restoredAdDrawerBtn}
        >
          {t('pages.ad.ad_is_restored_button')}
        </Button>
      }
      className="action"
    >
      <S.DrawerItem $isInTheMiddle>
        <S.RestoredAdDescription>
          <Typography.Body $variant="4">
            {t('pages.ad.ad_is_restored_subtitle')}
          </Typography.Body>
        </S.RestoredAdDescription>

        <Typography.Caption $variant="2">
          {t('pages.ad.ad_number')}
        </Typography.Caption>

        <S.AdNumber>{adDetails?.legacyResourceId}</S.AdNumber>
      </S.DrawerItem>

      <S.DrawerItem $isInTheMiddle>
        <S.PromotionTitle>
          <Typography.Title>
            {t('pages.ad.ad_is_restored_promotion')}
          </Typography.Title>
        </S.PromotionTitle>
        {adDetails &&
          promotions(
            t,
            getLessPrice(adDetails.bumpServices[0]),
            getLessPrice(adDetails.vipServices[0]),
            getLessPrice(adDetails.featuredServices[0]),
            adDetails.status === AdStatus.Published
          ).map(promotion => (
            <Promotion
              key={promotion.type}
              promotion={promotion}
              openDrawer={toggleDrawer}
              setType={setType}
            />
          ))}

        <PromotionDrawer
          portalSuccessModal
          isOpen={isDrawerOpen}
          toggle={toggleDrawer}
          onSuccessPayment={toggle}
          type={type}
        />
      </S.DrawerItem>
    </Drawer>
  );
};
